var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Header bg-blue flex-justify-between mb-5 p-1"},[_c('NavigationItem',{attrs:{"to":"/registration"}},[_vm._v(" Register ")]),_c('NavigationItem',{staticClass:"h3",attrs:{"to":"/"}},[_vm._v(" TEAM UP ")]),_c('NavigationItem',{attrs:{"to":"/students"}},[_vm._v(" Students ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }